import { useCallback, useContext, useRef } from 'react';

import { lastSearchesSyncKey } from 'config/storageKeys';

import { addDebugBarData, mapRpcDebugBarData } from 'utility/Debug/DebugBar';
import { CommunicationContext } from 'utility/Provide/Context/PageContext';
import { callApi } from 'utility/Request/callApi';

import { ApiEndpoint } from 'types/Request/endpoint';

import { ResponseStatus } from 'proto/Api/ResponseStatus';

export const useSaveLastSearch = () => {
    const { components } = useContext(CommunicationContext);
    const lastUrlRef = useRef('');
    const lastDestinationLabelRef = useRef('');

    return useCallback(
        async (destinationLabel: string) => {
            const url = window.location.href;
            if (
                url === lastUrlRef.current &&
                destinationLabel === lastDestinationLabelRef.current
            ) {
                // no change since last trigger -> skip

                return true;
            }
            const result = await callApi(ApiEndpoint.LastSearchesAdd, {
                requestData: {
                    url,
                    destinationLabel,
                },
            });
            addDebugBarData(
                mapRpcDebugBarData(result.parsedBody?.debugBar),
                ApiEndpoint.LastSearchesAdd
            );

            const success =
                result.parsedBody?.status === ResponseStatus.Success;
            if (success) {
                components.lastSearchesDataService?.deleteTempItemFromLocalStorage();
                // just save last values on success, so on failure it will be possibly retried after next list update
                lastUrlRef.current = url;
                lastDestinationLabelRef.current = destinationLabel;
                try {
                    window.localStorage.setItem(
                        lastSearchesSyncKey,
                        new Date().toString()
                    );
                } catch (_) {
                    //do nothing
                }
            }

            return success;
        },
        [components.lastSearchesDataService]
    );
};
